// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"3ba2957a","79":"3c0feebc","87":"f9ce5462","94":"72c0ba80","132":"4dfd266f","173":"c1ed79fa","177":"95ef1e8f","209":"dbf1d377","289":"b1c28f31","335":"bf81a5c5","713":"90e87857","824":"20d32a85"}[chunkId] + ".chunk.js";
};